import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { X, AlertTriangle } from 'lucide-react';
import styles from './DeleteModal.module.css';
import { ClienteCaso } from '../../../interfaces/cliente.types';

interface DeleteCasoModalProps {
    onClose: () => void;
    onConfirmDelete: (id: number) => Promise<void>;
    caseToDelete: ClienteCaso;
}

export const DeleteCasoModal: React.FC<DeleteCasoModalProps> = ({ onClose, onConfirmDelete, caseToDelete }) => {
    const [isLoading, setIsLoading] = useState(false);

    const handleDelete = async () => {
        setIsLoading(true);
        await onConfirmDelete(caseToDelete.id);
        // El isLoading se manejará por el cierre del modal en el componente padre.
    };
    
    const modalVariants = {
        hidden: { scale: 0.9, opacity: 0 },
        visible: { scale: 1, opacity: 1 },
        exit: { scale: 0.9, opacity: 0 }
    };

    return (
        <div className={styles.modalOverlay} onClick={onClose}>
            <motion.div 
                className={styles.modalContent}
                variants={modalVariants}
                initial="hidden"
                animate="visible"
                exit="exit"
                transition={{ type: 'spring', stiffness: 400, damping: 25 }}
                onClick={(e) => e.stopPropagation()}
            >
                <div className={styles.iconWrapper}>
                    <AlertTriangle size={48} className={styles.alertIcon} />
                </div>
                <h2 className={styles.title}>¿Está seguro?</h2>
                <p className={styles.text}>
                    Está a punto de eliminar permanentemente el caso de <strong>{caseToDelete.nombre_completo}</strong> (Exp: {caseToDelete.numero_expediente || 'N/A'}).
                </p>
                <p className={styles.warningText}>
                    Toda la información asociada, incluyendo pagos y audiencias, será eliminada. Esta acción no se puede deshacer.
                </p>
                <div className={styles.buttonGroup}>
                    <button onClick={onClose} className={styles.cancelButton} disabled={isLoading}>
                        Cancelar
                    </button>
                    <button onClick={handleDelete} className={styles.confirmButton} disabled={isLoading}>
                        {isLoading ? 'Eliminando...' : 'Sí, eliminar caso'}
                    </button>
                </div>
            </motion.div>
        </div>
    );
};